<div
  class="absolute top-0 left-0 right-0 z-1000 flex flex-col-reverse sm:flex-row items-center gap-1 bg-amber-600 text-white py-2 px-2 sm:px-4 text-sm shadow sm:gap-3"
  [class.justify-between]="isExerciseRoute()"
  [class.justify-center]="!isExerciseRoute()"
  [class.sm:justify-center]="isExerciseRoute()"
  role="banner"
>
  <span class="font-medium" i18n>Viewing as {{ impersonationLabel() }}</span>
  <div class="flex items-center gap-2 shrink-0">
    @if (isExerciseRoute()) {
      <p-button
        icon="fa fa-home"
        [attr.aria-label]="backToHomeLabel"
        [title]="backToHomeLabel"
        i18n-label
        severity="secondary"
        size="small"
        (onClick)="backToHome.emit()"
      />
    }
    <p-button
      [icon]="isAutoPlaybackMuted() ? 'far fa-volume-mute' : 'far fa-volume-up'"
      [attr.aria-label]="
        isAutoPlaybackMuted()
          ? unmuteAutomaticAudioLabel
          : muteAutomaticAudioLabel
      "
      [title]="
        isAutoPlaybackMuted()
          ? unmuteAutomaticAudioLabel
          : muteAutomaticAudioLabel
      "
      severity="secondary"
      size="small"
      (onClick)="toggleAutoPlaybackMuted.emit()"
    />

    <p-button
      icon="fa fa-user-slash"
      label="Stop impersonating"
      i18n-label
      severity="secondary"
      size="small"
      (onClick)="stopImpersonation.emit()"
    />
  </div>
</div>
